'use client';

import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import { rootUrl } from 'utils/links';

const StartEngineLogo = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 86 35" width="86" height="35" fill="none">
    <path
      d="M76.6669 17.6884C76.6669 18.8377 75.7384 19.7693 74.5929 19.7693C73.4475 19.7693 72.519 18.8377 72.519 17.6884C72.519 16.5391 73.4475 15.6075 74.5929 15.6075C75.7384 15.6075 76.6669 16.5391 76.6669 17.6884Z"
      fill="#FFFFFF"
    />
    <path
      d="M71.2229 6.57948C66.5683 8.05446 63.1863 12.5045 63.1863 17.765C63.1863 24.2294 68.2933 29.4698 74.5931 29.4698C80.893 29.4698 86 24.2294 86 17.765C86 12.5045 82.618 8.05446 77.9633 6.57948V9.98421C80.8656 11.3098 82.889 14.2949 82.889 17.765C82.889 22.4664 79.1748 26.2776 74.5931 26.2776C70.0114 26.2776 66.2972 22.4664 66.2972 17.765C66.2972 14.2949 68.3207 11.3098 71.2229 9.98421V6.57948Z"
      fill="#FFFFFF"
    />
    <path d="M72.7781 0H76.4076V14.0463H72.7781V0Z" fill="#FFFFFF" />
    <path
      d="M31.2074 0.111646C31.8351 0.0924663 32.4728 0.0429708 33.0931 0.153717C33.5704 0.391914 34.0583 0.840468 34.044 1.41462C34.0837 2.08591 34.0785 2.75909 34.0285 3.4297C34.6176 3.46621 35.2093 3.43837 35.7966 3.45754C35.8513 4.04592 35.7966 4.7568 35.2441 5.11008C34.9054 5.40519 34.443 5.3823 34.026 5.4386C34.1229 7.28169 34.0427 9.13035 34.0707 10.9759C34.1074 11.4789 33.8544 12.1873 34.4592 12.4397C34.8905 12.5635 35.3946 12.5016 35.8109 12.5016C35.8109 13.2235 35.8109 13.9228 35.8109 14.6727C34.7749 14.6727 33.6692 14.6701 32.6369 14.5637C32.208 14.4876 31.7624 14.2859 31.5368 13.8974C31.1813 13.3585 31.1763 12.6872 31.1813 12.0661C31.2018 8.08043 31.1484 4.09418 31.208 0.109789L31.2074 0.111646Z"
      fill="#FFFFFF"
    />
    <path
      d="M55.542 0.0281915C56.1698 0.00901198 56.8074 -0.0404835 57.4277 0.0702627C57.905 0.30846 58.3929 0.757013 58.3786 1.33116C58.4184 2.00246 58.4132 2.67564 58.3631 3.34625C58.9523 3.38275 59.5439 3.35491 60.1313 3.37409C60.186 3.96247 60.1313 4.67335 59.5788 5.02662C59.24 5.32174 58.7776 5.29885 58.3606 5.35515C58.4575 7.19824 58.3774 9.0469 58.4053 10.8925C58.442 11.3955 58.1891 12.1039 58.7938 12.3563C59.2251 12.48 59.7292 12.4182 60.1456 12.4182C60.1456 13.1401 60.1456 13.8394 60.1456 14.5892C59.1095 14.5892 58.0038 14.5867 56.9715 14.4803C56.5427 14.4042 56.0971 14.2025 55.8714 13.8139C55.5159 13.2751 55.511 12.6038 55.5159 11.9826C55.5365 7.99697 55.483 4.01073 55.5427 0.026335L55.542 0.0281915Z"
      fill="#FFFFFF"
    />
    <path
      d="M21.5329 4.0512C22.4652 3.2568 23.7318 3.00809 24.927 2.98396C26.1402 2.98396 27.4161 3.21473 28.4025 3.96211C29.2303 4.60493 29.6958 5.62887 29.7586 6.66271C28.8974 6.65446 27.3765 6.66271 27.0631 6.29149C26.6964 5.78355 26.2048 5.29663 25.5441 5.23971C24.774 5.17336 24.2962 5.1333 23.7387 5.41109C23.3036 5.60103 23.1619 6.18817 23.3477 6.59218C23.5742 7.03596 24.1296 7.08713 24.5671 7.21953C26.0134 7.64148 27.569 7.78625 28.8779 8.59056C29.6467 8.99456 30.0986 9.85393 30.1209 10.7034C30.1831 11.6314 29.9345 12.63 29.2552 13.3019C28.551 14.1062 27.469 14.4415 26.4429 14.5956C24.9034 14.7552 23.2321 14.7812 21.8368 14.0128C20.7076 13.3891 20.0798 12.0825 20.1588 10.8166C21.091 10.8216 22.0233 10.7758 22.9493 10.8445C23.0357 11.345 23.2241 11.9068 23.7032 12.161C24.528 12.5879 25.5236 12.5941 26.4062 12.3615C26.8785 12.2439 27.3242 11.8201 27.2309 11.298C27.168 10.9454 26.9307 10.7288 26.6591 10.5834C26.0811 10.274 25.4304 10.154 24.7903 10.0445C23.707 9.76793 22.5864 9.51983 21.6293 8.91661C21.2308 8.65038 20.9093 8.28506 20.6964 7.85692C20.4836 7.42877 20.387 6.95267 20.4161 6.47586C20.3968 5.54782 20.9009 4.69403 21.5348 4.05368L21.5329 4.0512Z"
      fill="#FFFFFF"
    />
    <path
      d="M46.3999 6.34754C46.4279 5.64285 46.2756 4.87258 45.7722 4.34792C45.0773 3.49103 43.9468 3.19591 42.8977 3.05362C41.6168 2.92988 40.2482 2.91008 39.0773 3.52011C38.0916 4.00145 37.3191 4.95857 37.201 6.06109C38.1276 6.03943 39.0549 6.07222 39.9816 6.02458C40.1382 5.51478 40.7075 5.35763 41.1786 5.28215C41.866 5.22894 42.6019 5.23513 43.2383 5.52963C43.7355 5.7437 43.7796 6.42426 43.5093 6.82888C42.8318 7.38571 41.9014 7.42221 41.0711 7.56142C39.9853 7.67155 38.8958 7.97471 37.9878 8.59031C37.2389 9.12671 36.8952 10.0566 36.8815 10.9525C36.8678 11.8483 37.0214 12.8284 37.6634 13.504C38.4173 14.2835 39.5105 14.6659 40.5845 14.669C42.0282 14.6776 43.6679 14.717 44.8667 13.8187C45.8674 13.1381 46.3197 11.8162 46.3744 10.6339C46.4291 9.20652 46.3769 7.77487 46.3999 6.34754ZM43.2346 11.5446C42.6069 12.3798 41.4471 12.5963 40.4695 12.3922C40.0493 12.3148 39.7373 11.9523 39.6354 11.5532C39.5639 11.036 39.5702 10.447 39.9294 10.0288C40.3508 9.68168 40.9045 9.56846 41.4241 9.44843C42.206 9.30799 42.9624 9.05804 43.7032 8.7753C43.715 9.70519 43.8368 10.7526 43.2346 11.5446Z"
      fill="#FFFFFF"
    />
    <path
      d="M49.3339 4.88409C50.5147 3.77415 52.1928 3.42891 53.7708 3.39117C53.9081 3.3788 54.125 3.39115 54.125 3.59534C54.125 4.51039 54.102 5.42325 54.102 6.33926C53.1971 6.3838 52.1468 6.18829 51.3991 6.82617C50.8398 7.30875 50.6974 8.09078 50.69 8.79176C50.6999 10.7283 50.6838 12.7374 50.6999 14.6727H47.7987C47.795 12.7374 47.7913 10.7413 47.7987 8.80723C47.8267 7.37866 48.2879 5.89936 49.3314 4.88347L49.3339 4.88409Z"
      fill="#FFFFFF"
    />
    <path
      d="M10.4335 24.4178C10.492 22.8512 10.3596 21.1808 9.45963 19.8394C8.58144 18.4567 6.87913 17.7978 5.28371 17.8231C3.89215 17.7612 2.42477 18.2086 1.47448 19.2591C0.491253 20.2645 0.159367 21.6893 0.00647548 23.0387C-0.0326796 24.205 0.102188 25.3898 0.508033 26.4898C0.98411 27.7637 2.01768 28.8408 3.32658 29.264C4.9599 29.7738 6.83935 29.6352 8.29865 28.7029C9.30053 28.0805 9.95249 27.0324 10.2769 25.9187C10.2769 25.9187 8.66938 25.9187 7.83501 25.9249C7.22406 25.9781 7.22434 26.4655 6.48944 26.887C5.70634 27.2508 4.71441 27.2242 3.98413 26.7503C3.26381 26.2231 3.08295 25.2485 2.98972 24.4182C5.37573 24.4182 7.83501 24.4178 10.4335 24.4178ZM2.98351 22.4442C3.06741 21.7722 3.22403 21.0261 3.78152 20.5788C4.68271 19.8852 6.16377 19.9236 6.92512 20.8096C7.27876 21.2822 7.39001 21.869 7.43413 22.4444L2.98351 22.4442Z"
      fill="#FFFFFF"
    />
    <path
      d="M60.6237 24.4178C60.6821 22.8512 60.5498 21.1808 59.6498 19.8394C58.7716 18.4567 57.0693 17.7978 55.4739 17.8231C54.0823 17.7612 52.615 18.2086 51.6647 19.2591C50.6814 20.2645 50.3495 21.6893 50.1967 23.0387C50.1575 24.205 50.2924 25.3898 50.6982 26.4898C51.1743 27.7637 52.2079 28.8408 53.5168 29.264C55.1501 29.7738 57.0295 29.6352 58.4888 28.7029C59.4907 28.0805 60.1427 27.0324 60.4671 25.9187C60.4671 25.9187 58.8596 25.9187 58.0252 25.9249C57.4142 25.9781 57.4145 26.4655 56.6796 26.887C55.8965 27.2508 54.9046 27.2242 54.1743 26.7503C53.454 26.2231 53.2731 25.2485 53.1799 24.4182C55.6648 24.4178 58.0926 24.4178 60.6237 24.4178ZM53.1737 22.4442C53.2576 21.7722 53.4142 21.0261 53.9717 20.5788C54.8729 19.8852 56.3539 19.9236 57.1153 20.8096C57.4689 21.2822 57.5802 21.869 57.6243 22.4444L53.1737 22.4442Z"
      fill="#FFFFFF"
    />
    <path
      d="M17.129 17.8327C18.2825 17.9125 19.1669 18.1328 20.3608 18.9835C21.3322 19.7878 21.6355 21.1155 21.6542 22.3183C21.6759 24.6501 21.6542 26.982 21.6653 29.3132C21.1228 29.3207 20.5783 29.3374 20.0357 29.3207C19.3595 29.2891 18.7741 28.6667 18.7878 27.9898C18.7648 26.0632 18.7878 24.1335 18.7778 22.2069C18.7635 21.7014 18.6902 21.1489 18.3129 20.7771C17.4894 19.9165 15.9574 19.9443 15.1507 20.8136C14.7995 21.2256 14.761 21.793 14.7436 22.309C14.7436 24.647 14.7498 26.9832 14.7399 29.3213C13.7573 29.325 12.774 29.3343 11.7927 29.3126C11.7852 27.0593 11.7852 24.8058 11.7927 22.5521C11.8617 21.3215 12.0537 19.9425 13.0407 19.0874C14.2812 17.9744 15.6752 17.751 17.129 17.8327Z"
      fill="#FFFFFF"
    />
    <path
      d="M33.3387 23.2897C33.3287 22.3084 33.2865 21.295 32.8893 20.3818C32.6103 19.7402 31.8613 18.9236 31.2448 18.5721C30.4107 18.0549 29.1217 17.74 28.0092 17.74C27.4561 17.74 25.4474 17.7709 24.2597 18.923C23.0975 20.1498 22.7295 21.8927 22.6786 23.5285C22.709 24.735 22.8774 25.9872 23.5126 27.0402C24.0247 27.8445 24.6935 28.5993 25.5903 28.9885C26.7233 29.5286 28.1223 29.5793 29.2367 28.9693C29.7339 28.7033 30.09 28.2572 30.4511 27.8377C30.4754 28.6309 30.4636 29.4636 30.0919 30.1888C29.668 31.019 28.7283 31.6346 27.7724 31.4942C27.0764 31.3804 26.4051 30.9992 26.0372 30.3892C25.0185 30.3793 24.0011 30.3892 22.9819 30.3855C23.2646 31.5845 23.9645 32.752 25.0739 33.3552C26.1143 33.9343 27.3361 34.0587 28.5064 33.9851C29.7849 33.7673 30.7985 33.6008 32.0845 32.5113C33.0416 31.6062 33.3026 30.2314 33.3275 28.9693C33.3486 27.0767 33.3324 25.1823 33.3387 23.2897ZM30.4685 23.4066C30.4685 24.3916 30.3716 25.4966 29.6537 26.2471C29.2516 26.7074 28.6276 26.9165 28.0279 26.9084C27.4182 26.9084 26.7407 26.7921 26.3119 26.3201C25.865 25.8678 25.7121 25.225 25.6139 24.6205C25.5083 23.4394 25.517 22.1859 26.0695 21.1038C26.2951 20.5829 26.8103 20.2265 27.3579 20.1077C28.1304 19.9339 29.0397 20.0422 29.5953 20.6553C30.2199 21.4243 30.4996 22.4266 30.4685 23.4066Z"
      fill="#FFFFFF"
    />
    <path
      d="M44.1244 17.819C46.5955 17.819 47.8503 18.8547 48.3916 19.745C48.9038 20.5944 49.0548 21.6116 49.0523 22.591C49.0573 24.8467 49.0573 27.1019 49.0523 29.3564C48.2363 29.3093 47.2773 29.5983 46.5949 29.0093C46.2549 28.7166 46.1598 28.231 46.1598 27.8016C46.1598 25.9043 46.1598 24.0069 46.1598 22.1096C46.1536 21.6518 46.0554 21.1655 45.7247 20.8258C44.9709 20.0692 43.657 19.9652 42.8092 20.6291C42.312 20.9384 42.1635 21.5621 42.1411 22.1096C42.1312 24.5275 42.1461 26.9435 42.1337 29.3613H39.2126C39.1809 27.066 39.2039 24.7657 39.1995 22.4709C39.271 21.4897 39.3916 20.4447 39.9863 19.625C40.3909 19.0397 41.5874 17.819 44.1244 17.819Z"
      fill="#FFFFFF"
    />
    <path
      d="M34.7939 17.8243C35.3198 17.8252 35.8225 17.8154 36.3371 17.8241C37.0985 17.8086 37.7666 18.5213 37.7479 19.2687C37.7554 22.5301 37.7554 26.0624 37.7479 29.3238H34.7939C34.7939 25.5609 34.7939 21.6683 34.7939 17.9308V17.8243Z"
      fill="#FFFFFF"
    />
  </svg>
);

const TopNavSkeleton = ({ hideBanners = true }) => {
  return (
    <Box
      id="main-top-nav"
      sx={{
        '.MuiButton-outlinedSuccess': {
          backgroundColor: 'white !important',
        },
      }}
    >
      {hideBanners && (
        <style>{`
          [data-cy="homepage-promo-banner"],
          [data-cy="explore-promo-banner"],
          [data-cy="banner-carousel"] {
            display: none !important;
            height: 0 !important;
          }
        `}</style>
      )}
      <Box
        component="header"
        data-topnav-skeleton
        sx={{
          position: 'fixed',
          top: 0,
          zIndex: 50,
          width: '100%',
          backgroundColor: '#185C65',
        }}
      >
        <Box sx={{ width: '100%' }}>
          <Grid
            container
            alignItems="center"
            justifyContent="space-between"
            sx={{ height: '64px', px: 3, width: '100%', maxWidth: 'none', m: 0 }}
          >
            {/* Logo and Navigation */}
            <Grid item xs="auto">
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 4, pl: 1 }}>
                <button
                  onClick={() => {
                    window.location.href = rootUrl;
                  }}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    backgroundColor: 'transparent',
                    border: 'none',
                    cursor: 'pointer',
                    padding: 0,
                  }}
                  aria-label="StartEngine Home"
                >
                  <StartEngineLogo />
                </button>

                {/* Desktop Navigation */}
                <Box
                  component="nav"
                  className="desktop-nav"
                  sx={{
                    display: { xs: 'none', md: 'flex' },
                    alignItems: 'center',
                    gap: 3,
                  }}
                >
                  <button
                    onClick={() => {
                      window.location.href = `${rootUrl}/invest`;
                    }}
                    style={{
                      fontSize: '14px',
                      fontWeight: 500,
                      color: 'rgba(255, 255, 255, 0.9)',
                      backgroundColor: 'transparent',
                      border: 'none',
                      cursor: 'pointer',
                    }}
                  >
                    Invest
                  </button>
                </Box>
              </Box>
            </Grid>

            {/* Right side - Empty during loading */}
            <Grid item xs="auto">
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 3, pr: 1 }}>
                {/* Empty space for search and other elements that will appear after loading */}
                <Box sx={{ width: { xs: '40px', md: '200px' } }} />
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Box>
  );
};

TopNavSkeleton.propTypes = {
  hideBanners: PropTypes.bool,
};

export default TopNavSkeleton;
